<template>
  <div class="home-page" style="min-height: 100%;">
	  <noProcess></noProcess>

	  <header class="header-top">
		<div class="user-logo">
			<van-card :thumb="ADMIN.USER_IMAGE" :title="'您好，'+ADMIN.USER_NAME"/>
			<!-- <van-card  :title="'您好，'+ADMIN.USER_NAME"/>  -->
		</div>
	</header>
	<div class="reports">
		<a :href="WEB_URL+'reports/'">
			<i class="van-icon van-icon-like"><!----></i>
			<span>打卡/申报</span>
		</a>
	</div>
	<!-- 移动定位开始 -->
	<div id='container' style="display: none;"></div>
	<div id="tip" style="display: none;"></div>	
	<div id="tip-show" style="display: none;">
		<p id="longitude"></p><p id="latitude"></p><p id="address"></p>
		<p id="province"></p><p id="city"></p><p id="district"></p><p id="road"></p>
	</div>
	<!-- 移动定位结束 -->
	<div class="content home-index pd20" style="margin-top:-65px;">
		<div class="home_lists navs box-shadow pd10">
			<van-grid :border="false" :column-num="3">
				<van-grid-item :url="WEB_URL+'news/'+source" :icon="WEB_URL+'images/icon/home_news.png'" text="新闻公告" />
				<van-grid-item :url="WEB_URL+'together/'+source" :icon="WEB_URL+'images/icon/home_love.png'" text="在一起" />
				<van-grid-item :url="WEB_URL+'ittopics/'+source" :icon="WEB_URL+'images/icon/home_topic.png'" text="IT热点" />
				<van-grid-item id="home_need_count" :url="WEB_URL+'list/'+source" :icon="WEB_URL+'images/icon/home_apply.png'" text="待办"  />
			    <van-grid-item :url="WEB_URL+'utility/'+source" :icon="WEB_URL+'images/icon/home_utility.png'" text="应用" />
				<van-grid-item @click="onTopicsConfirm()" id="home_topics_count" :icon="WEB_URL+'images/icon/home_sms.png'" text="消息中心"/> 
			</van-grid>
		</div>
		<h4 class="mt15 left">IT热点</h4>
		<div class="home-it pt15">
			<i class="notice van-icon van-icon-volume van-notice-bar__left-icon"></i>
			<van-swipe :show-indicators="false" :autoplay="2000" vertical>
			  <van-swipe-item v-for="item in it_list">
				  <a :href="item.DETAIL_URL+'&token='+URLTOKEN">
					  {{item.TITLE}}
				  </a>
			  </van-swipe-item>
			</van-swipe>
		</div>
		<!-- <div class="home_lists box-shadow mt10 punch-oa">
			<h4>考勤打卡</h4>
			<van-card
			  id="up_show"
			  class="border-bottom"
			  desc="未打卡"
			  title="上班"
			  :thumb="WEB_URL+'images/icon/work.png'"
			>
				<div slot="num">
					<van-button class="cancel up" size="middle">签到</van-button>
					<van-button class="active up" size="middle" @click="onConfirm(0)">签到</van-button>
				</div>
			</van-card>
			<van-card
			  id="down_show"
			  desc="未打卡"
			  title="下班"
			  :thumb="WEB_URL+'images/icon/down-work.png'"
			>
				<div slot="num">
					<van-button class="cancel down" size="middle">签到</van-button>
					<van-button class="active down" size="middle" @click="onConfirm(1)">签到</van-button>
				</div>
			</van-card>
			<div class="user-location">
				<van-icon name="location" />
				<div class="location"> </div>
				<p class="right refresh" @click="onReplay"><van-icon name="replay" /></p>
			</div>
		</div>-->
		<div class="home_lists box-shadow mt20">
			<h4>新闻公告
			<span class="right more f14"><a id="news_more" class="cblue" href="/news/">更多<span class="fst">&gt;&gt;</span></a> </span>
			</h4>
			<van-tabs :border="false" @click="onApply" v-model="joa_activeTabName">
			  <van-tab v-for="(item_tabs,i) in tabs_lists" :name="item_tabs">
				<div slot="title">{{item_tabs}}</div>
				<div v-if="i==2" style="margin-top: 10px;">
					<div class="img_lists" v-for="(item,index) in news_list" :id="item.id">
						<a v-if="item.post_link != ''"  :href="item.post_link">
							<van-card
							  :desc="toTimeDate(item.post_date)"
							  :title="item.post_title"
							>
							</van-card>
							<van-image v-if="item.post_image.indexOf('portal') !== -1" :src="CECPORT_IMG_URL+'bbs/data/attachment/'+item.post_image" />
							<van-image v-else-if="item.post_image.indexOf('Cms') !== -1" :src="CECPORT_IMG_URL+item.post_image" />
							<van-image v-else :src="CECPORT_IMG_URL+'newcecport/upload/'+item.post_image" />
						</a>
						<a v-else :href="WEB_URL+'detail?nid='+item.id">
							<van-card
							  :desc="toTimeDate(item.post_date)"
							  :title="item.post_title"
							>
							</van-card>
							<van-image v-if="item.post_image.indexOf('portal') !== -1" :src="CECPORT_IMG_URL+'bbs/data/attachment/'+item.post_image" />
							<van-image v-else-if="item.post_image.indexOf('Cms') !== -1" :src="CECPORT_IMG_URL+item.post_image" />
							<van-image v-else :src="CECPORT_IMG_URL+'newcecport/upload/'+item.post_image" />
						</a>
					</div>
				</div>
				<div v-else style="margin-top: 10px;">
					<div class="news_lists" v-for="(item,index) in joa_list" :id="item.ID">
						<a :href="item.DETAIL_URL+'&token='+URLTOKEN">
							<van-card
							  :desc="toTimeDate(item.CREATE_DATETIME)"
							  :title="item.TITLE"
							>
							</van-card>
						</a>
					</div>
				</div>
			</van-tab>
		</van-tabs>		
		</div>
	</div>
	<input id="oa_api_ip" :value="OA_API_IP" style="display: none;"/>
	<input id="web_url" :value="WEB_URL" style="display: none;"/>
	<input id="oa_punch_location" value="0" style="display: none;" /><!-- 0不在公司附近1在公司附近 -->
	<Footer></Footer> <!-- 尾部 -->
	<!-- 打卡弹框 -->
	<van-dialog
	   class="punch"
	   v-model="is_show"
	   confirm-button-text="继续打卡"
	   show-cancel-button
	   @confirm="onPunch(1)"
	 >
	 <div class="punch-title" slot="title"><van-icon name="warning-o" /><p>打卡提示</p></div> 
	 <div class="punch-warning">
	 		<div>
	 			<p class="punch-txt">下班</p><p class="punch-time">17：00</p>
	 		</div>
	 </div> 
	 <div class="punch-desc">还没到下班时间呢，亲确定要下班打卡吗？</div>
	 </van-dialog> 
	 
	 <div id="closeshow">
		 <van-popup 
		 class="close-tip"
		 closeable
		 close-icon="close"
		 close-icon-position="top-right"
		 v-model="is_close" 
		 :style="{ height: '300px',width: '300px'}">
		 <div class="van-toast van-toast--middle">
			 <i class="van-icon van-icon-success van-toast__icon"></i>
			 <div class="van-toast__text">打卡成功</div>
		</div>
		</van-popup>
	</div>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  async created() {
	if(this.ADMIN_USER_NAME!=null){
		 //setInterval(this.getTime,1000);
		 await this.getPunchConfig(); //公司打卡位置
		 this.wx_location = await this.getMap();
		 this.getAddress(this.wx_location);
	}
  },
  async mounted(){
	this.getData(516,"公司公告");
	this.getData(517,"IT热点"); //IT热点
	//重新刷新定位
	await setTimeout(()=>{
		this.onReplayRepeat();	
	},300000);
	await setTimeout(()=>{
		this.onReplayRepeat();	
	},600000);
	await setTimeout(()=>{
		this.onReplayRepeat();	
	},1200000);


	  if(this.CoreNew.WEB_URL_SOURCE){
		  this.source='?source='+this.CoreNew.WEB_URL_SOURCE
	  }
  },
  data() {
    return {
		ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
		OA_URL:this.CoreNew.OA_URL,
		FSSC_URL:this.CoreNew.FSSC_URL,
		EHR_URL:this.CoreNew.EHR_URL,
		WEB_URL:this.CoreNew.WEB_URL,
		CECPORT_IMG_URL:this.CoreNew.CECPORT_IMG_URL,
		URLTOKEN:encodeURIComponent(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))),
		OA_API_IP:this.CoreNew.OA_API_IP,
		ADMIN_USER_NAME:JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),
		ADMIN_USER_IMAGE:JSON.parse(localStorage.getItem('LS_ADMIN_USER_IMAGE')),
		BASE64_ADMIN_USER_NAME:Base64.encode(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME'))),
		is_show:false,
		is_close:false,
		is_reports:false,//是否有申报记录
		nav_lists:[],
		joa_activeTabName:"公司公告",
		news_list: [], //新闻
		it_list: [], //IT
		joa_list: [], //公司公告
		gettime:"",
		tabs_lists: ["公司公告","内部新闻","行业新闻"],
		punchConfig_list:[],
		wx_appId:"",
		wx_timeStamp:"",
		wx_nonceStr:"",
		wx_signature:"",
		wx_location:"",
		source: ''
	}
  },
  methods:{
		async getMap() {
			return new Promise((resolve, reject) => {
				axios.get("https://mb.cecport.com?sign=1", {
				}).then(function (response) {
					var data = response.data.split(',');
					this.wx_appId=data[0];this.wx_timeStamp=data[1];
					this.wx_nonceStr=data[2];this.wx_signature=data[3];
					wx.config({
					      debug: false,
						  appId: this.wx_appId,
					      timestamp: this.wx_timeStamp,
					      nonceStr: this.wx_nonceStr,
					      signature: this.wx_signature,
					      jsApiList: [
					      		'getLocation'
					      ]
					});
					wx.ready(function(){
						wx.getLocation({
							type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
							success: function (res) {
								var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
								var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
								//var speed = res.speed; // 速度，以米/每秒计
								//var accuracy = res.accuracy; // 位置精度
								resolve(longitude+","+latitude);
							}
						 });   
					}); 
					wx.error(function(res){
						//reject(false);
						//alert("error"+JSON.stringify(res))
						console.log("error"+JSON.stringify(res));
						// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
					}); 
				}.bind(this)).catch(function (error) {
					reject(false);
					//alert("请求微信--定位--失败"+error);
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求微信--定位--失败"+error);//记录错误
					console.log("请求微信--定位--失败"+error); 
				});
			});
	    },
		async getAddress(user_location) {
			var data = user_location.split(',');
			var lng=data[0];
			var lat=data[1];
			var map = new AMap.Map('container', {
			   center:[lng,lat],
			   zoom:12,
			   resizeEnable: true
			});
			var geocoder = new AMap.Geocoder({
			    city: "010", //城市设为北京，默认：“全国”
			});
			var lnglat  = lng + "," + lat;
			var punchConfig_list=this.punchConfig_list;
			var WX_VUE=this;
			geocoder.getAddress(lnglat, function(status, result) {
				if (status === 'complete'&&result.regeocode) {
					//var address = result.regeocode.formattedAddress;
					var data=result.regeocode;
					data["longitude"]=lng;	
					data["latitude"]=lat;
					for (var i = 0; i < punchConfig_list.length; i++) {
						var is_location=WX_VUE.makePunch(data,punchConfig_list[i].BASELONGITUDE,punchConfig_list[i].BASELATITUDE,punchConfig_list[i].BASEACCURACY,i,punchConfig_list.length);
						if(is_location==true){
							break;
						}
					}
					$("#loading").hide();
				}else{
					console.log('高德地图获取地址失败')
				}
			});
		},
		makePunch: function (data,company_Lng,company_Lat,company_Distance,locations_active,locations_length) {
			var myplace = ''; //我的位置
			var mycity = ''; //我所在的城市
			//company_Lng="114.000222";var company_Lat="22.58936";var company_Distance=150; //塘朗 
			//company_Lng="114.047871";var company_Lat="22.541418";var company_Distance=120; //信息
			//114.00009,22.589629
			var str = ['定位成功'];
			str.push('经度：' + data.longitude);
			str.push('纬度：' + data.latitude);
			str.push('地址：' + data.formattedAddress);
			document.getElementById('tip').innerHTML = str.join('<br>');
			myplace = data.formattedAddress; //我的位置
			mycity = data.addressComponent.city; //我所在的城市	
			localStorage.setItem('LS_CITY', JSON.stringify(mycity));
			//console.log(data);
			//提交地址信息
			$("#tip-show #longitude").html(data.longitude);
			$("#tip-show #latitude").html(data.latitude);
			$("#tip-show #address").html(data.formattedAddress);
			$("#tip-show #province").html(data.addressComponent.province);
			$("#tip-show #city").html(data.addressComponent.city);
			$("#tip-show #district").html(data.addressComponent.district);
			$("#tip-show #road").html(data.addressComponent.street+data.addressComponent.streetNumber);
			// 经纬度计算
			var start = new LngLat(data.longitude, data.latitude);
			var end = new LngLat(company_Lng,company_Lat);//公司地址
			var distance=calculateLineDistance(start, end);
			$(".user-location .location").html(data.formattedAddress);
			/*获取是否有打卡记录*/
			$.ajax({
				type:"POST",
				url:$("#oa_api_ip").val()+"joa-business/mobile/queryPunch",
				dataType:"json",
				async:false,
				headers:{'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))},
				data:{userName:JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME'))},
				success:function(response){
					var $rs=response.data;
					if(response.flag==true){
						var $res=JSON.parse(response.data);
						if(response.data.indexOf('"UpTime":"无"') == -1){
							$("#up_show .van-card__desc").html(JStoTimeHFM($res.UpTime));
						}	
						if(response.data.indexOf('"DownTime":"无"') == -1){
							$("#down_show .van-card__desc").html(JStoTimeHFM($res.DownTime));
						}
						if(distance>company_Distance){
							$(".user-location .location").html(data.formattedAddress+"(距离还有"+parseInt(distance)+"米)");
							$(".punch-oa .cancel").show();
							$(".punch-oa .active").hide();
							//$("#oa_punch_location").val(0);
							if((locations_active+1)==locations_length){
								return true;
							}else{
								return false;
							}
						}else{
							if(response.data.indexOf('"UpTime":"无"') == -1){ //已上班
								$(".punch-oa .cancel.up span").html("已签");
								$(".punch-oa .cancel.up").show();
								$(".punch-oa .active.up").hide();
								$(".punch-oa .cancel.down").hide();
								$(".punch-oa .active.down").show();
							}else{
								var hour=new Date().getHours();
								if(hour>16){ //超过17不允许打下班卡
									$(".punch-oa .cancel.up").show();
									$(".punch-oa .active.up").hide();
								}else{
									$(".punch-oa .cancel.up").hide();
									$(".punch-oa .active.up").show();
								}
								$(".punch-oa .cancel.down").hide();
								$(".punch-oa .active.down").show();
							}
							return true;
						}
					}
				},
				error:function(){
					alert("请求--打卡信息--失败"+error);
					console.log("请求--打卡信息--失败"+error); 
				}
			});
		},
		/*async getPunchRecords() {
	    	let post_data = new FormData();
	    	post_data.append("userName",JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
	    	return new Promise((resolve, reject) => {
				axios.post(this.CoreNew.OA_API_IP+"joa-business/mobile/queryPunch",post_data,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
					if(response.data.flag==true){
						resolve(response.data.data);
					}else{
						reject(false);
					}
				}.bind(this)).catch(function (error) { 
					//alert("请求--获取打卡记录--失败"+error); 
					reject(false);
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--获取打卡记录--失败"+error);//记录错误
					console.log("请求--获取打卡记录--失败"+error); 
				});
			})
	    },*/
		async getPunchConfig() {
			let post_data = new FormData();
			post_data.append("userName",JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
			return new Promise((resolve, reject) => {
				axios.post(this.CoreNew.OA_API_IP+"joa-business/mobile/queryPunchConfig",post_data,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
					if(response.data.flag==true){
						this.punchConfig_list=response.data.data;
						resolve(true);
						//alert(this.punchConfig_list[0].BASELONGITUDE)
					}else{
						resolve(false);
					}
				}.bind(this)).catch(function (error) { 
					reject(false);
					//alert("请求--获取打卡工作位置信息--失败"+error); 
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--获取打卡工作位置信息--失败"+error);//记录错误
					console.log("请求--获取打卡工作位置信息--失败"+error); 
				});
			});
		},
		clostTop: function () {
			var time = 3;
			var timer = setInterval(function() {
				time--;
				if(time == 0) {
					this.is_close=false;
					clearInterval(timer);//清楚定时
				}
			}, 1000);	
		},
		getTopicsCount: function () {
			$("#home_topics_count .van-info").show();
			axios.get(this.CoreNew.OA_API_IP+"joa-business/mobile/unreadMessageSum/",{
				headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
			}).then(function (response) {
				var $rs=response.data;
				if($rs.flag==true){	
					if($rs.data.TOTAL>0){
						$("#home_topics_count .van-info").show();
						$("#home_topics_count .van-info").html($rs.data.TOTAL);
					}
				}
			}.bind(this)).catch(function (error) { 
				//alert("请求--消息总数显示--失败"+error);
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--消息总数显示--失败"+error);//记录错误
				console.log("请求--消息总数显示--失败"+error); 
			});
		},
		//新闻公告516，消息中心636，IT热点517，在一起518
		onApply: function (name,title) {
			this.news_list=[];this.joa_list=[];
			if(name=="行业新闻"){
				$("#news_more").attr("href","/news?type=3");
				this.getNews(); 	
			}else if(name=="内部新闻"){
				$("#news_more").attr("href","/news?type=2");
				this.getData(516,"公司新闻");
			}else{ //公司公告
				$("#news_more").attr("href","/news");
				this.getData(516,"公司公告"); 
			}
		},
		getData: function (nid,sType) {
			if(sType=="IT热点"){
				var json_data = {"TYPE":"","IS_HOME":"Y"};
			}else{
				var json_data = {"TYPE":sType,"IS_HOME":"Y"};
			}
			axios.post(this.CoreNew.OA_API_IP+"joa-business/joatools/action/"+nid+"/1/3/",json_data,{
				headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
			}).then(function (response) {
				if(response.data.flag==true){
					if(sType=="IT热点"){
						if(response.data.data.total==0){
							this.it_list=[];
						}else{
							var $list=response.data.data["records"];
							this.it_list=$list;
						}
					}else{
						if(response.data.data.total==0){
							this.joa_list=[];
						}else{
							var $list=response.data.data["records"];
							this.joa_list=$list;
						}
					}
				}
			}.bind(this)).catch(function (error) { 
				//alert("请求--公司公告--失败"+error); 
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--公司公告--失败"+error);//记录错误
				console.log("请求--公司公告--失败"+error); 
			});
		},
		getNews: function () {
		  axios.get(this.CoreNew.CECPORT_URL+"icapi/getNews/", { 
		  	params: {pageSize:3,page:1}
		  }).then(function (response) {
			if(response.data.status==1){
				if(response.data.total==0){
					this.news_list=[];
				}else{
					var $rs=response.data;
					this.news_list=$rs.lists;
					//console.log(news_list)
				}
			}
		  }.bind(this)).catch(function (error) { 
		  	//alert("请求--行业新闻--失败"+error);
			this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--行业新闻--失败"+error);//记录错误
		  	console.log("请求--行业新闻--失败"+error); 
		  });
		},
		async onReplayRepeat() {
			this.wx_location = await this.getMap();//获取定位
			this.getAddress(this.wx_location);	
		}, 
		async onReplay() {
			$("#loading").show();
			this.wx_location = await this.getMap();//获取定位
			this.getAddress(this.wx_location);	
		},  
		onTopicsConfirm:function(){
			this.$dialog.alert({
			    title: '温馨提示',
				message:'功能升级中，敬请期待！'
			})
		},
		checkReports:function(){
			//检查是否有申报记录
			let r_post_data = new FormData();
			r_post_data.append("fUserName",JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
			return new Promise((resolve, reject) => {
				axios.post(this.CoreNew.OA_API_IP+"joa-business/mobile/queryPersonInfo/",r_post_data,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
					var $rs=JSON.parse(response.data.data);
					if(response.data.flag==true){
						if($rs.length>0){
							resolve(true);
						}else{
							resolve(false);
						}
					}else{
						resolve(false);
					}
				}.bind(this)).catch(function (error) {
					reject(false);
					//alert("请求--个人申报记录--失败"+error);
					//this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--个人申报记录--失败"+error);//记录错误
					//console.log("请求--个人申报记录--失败"+error);
				});
			});
		},
		async onConfirm (type) {
			this.is_reports = await this.checkReports();
			if(this.is_reports==true){
				var hour=new Date().getHours();
				if(type==1 && (hour<17)){
					//请先打上班卡
					if($(".punch-oa .cancel.up").html().indexOf("已签")>0){
						this.is_show=true;
					}else{
						this.$toast.setDefaultOptions({ duration: 3000});
						this.$toast("请先打上班卡");
					}
				}else{
					this.onPunch(type);
				}
			}else{
				this.$dialog.confirm({
				    title: '请填写个人信息申报'
				})
				.then(() => {
				  window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'reports/';
				})
			}
		},
		onPunch:function(punchtype){
			$("#closeshow").show();
			var HFMtime=this.getTimeHFM();//操作时间
			this.is_show=false;$("#loading").show();
			//触发打卡
			let post_data = new FormData();
			post_data.append("workPunchTypeDb",punchtype); //0上班，1下班
			post_data.append("sourceType",1);//PC:0,微信:1,钉钉:2
			post_data.append("userName",JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME'))); 
			post_data.append("uuid",JSON.parse(localStorage.getItem('LS_QWX_DEVICEID')));//设备号
			post_data.append("macIp",""); 
			post_data.append("longitude",$("#tip-show #longitude").html()); 
			post_data.append("latitude",$("#tip-show #latitude").html()); 
			post_data.append("accuracy",25); 
			post_data.append("address",$("#tip-show #address").html()); 
			post_data.append("province",$("#tip-show #province").html());
			post_data.append("city",$("#tip-show #city").html());
			post_data.append("district",$("#tip-show #district").html());
			post_data.append("road",$("#tip-show #road").html());
			post_data.append("netType","");
			post_data.append("operatorType","");
			axios.post(this.CoreNew.OA_API_IP+"joa-business/mobile/savePunch",post_data,{
				headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
			}).then(function (response) {
				var $rs=response.data;
				//if($rs.flag==true && ($rs.data.indexOf('"UpTime":"无"') == -1 || $rs.data.indexOf('"DownTime":"无"') == -1)){
				if($rs.flag==true){	
					//var $res=JSON.parse($rs.data.substring(1,$rs.data.length-1));
					//var $res=$rs.data.substring(1,$rs.data.length-1);
					$("#loading").hide();
					this.is_close=true;
					//this.$toast.success('打卡成功');
					if(punchtype==0){
						$(".punch-oa .cancel.up span").html("已签");
						$("#up_show .van-card__desc").html(HFMtime);
						
						$(".punch-oa .active.up").hide();
						$(".punch-oa .cancel.up").show();
					}else{
						$("#down_show .van-card__desc").html(HFMtime);
					}
					$(".punch-oa .cancel.down").hide();
					$(".punch-oa .active.down").show();	
					
					var time = 3;
					var timer = setInterval(function() {
						time--;
						if(time == 0) {
							$("#closeshow").hide();
							clearInterval(timer);//清楚定时
						}
					}, 1000);		
				}else{
					$("#loading").hide();
					this.is_close=false;
				}
			}.bind(this)).catch(function (error) { 
				this.is_close=false;
				//alert("请求--保存打卡--失败"+error);
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--保存打卡--失败"+error);//记录错误
				console.log("请求--保存打卡--失败"+error); 
			});
		},
		toTimeDate:function(times){
			var timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
			var timestr = timearr[0] + "-" + timearr[1] + "-" + timearr[2];
			return timestr;
		},
		toTimeHFM:function(times){
			var timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
			var timestr = ""+timearr[3]+":" + timearr[4] + ":" + timearr[5]
			//var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
			return timestr;
		},
		getTimeHFM:function(){
		    let hh = new Date().getHours()<10 ? "0"+new Date().getHours() : new Date().getHours();
		    let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
		    let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
		    return hh+":"+mf+":"+ss;
		},
		getTime:function(){
			var _this = this;
		    let yy = new Date().getFullYear();
		    let mm = new Date().getMonth()+1;
		    let dd = new Date().getDate();
		    let hh = new Date().getHours()<10 ? "0"+new Date().getHours() : new Date().getHours();
		    let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
		    let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
		    this.gettime = hh+":"+mf+":"+ss;
		},
		getFullTime:function(){
			let yy = new Date().getFullYear();
		    let mm = new Date().getMonth()+1;
		    let dd = new Date().getDate();
		    //let hh = new Date().getHours();
			let hh = new Date().getHours()<10 ? "0"+new Date().getHours() : new Date().getHours();
		    let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
		    let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
		    return yy+"-"+mm+"-"+dd+" "+hh+":"+mf+":"+ss;
		}
  }
}
function JStoTimeHFM(times){
	var timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
	if(parseInt(timearr[3])<10 && timearr[3].length==1){
		var timestr = "0"+timearr[3]+":" + timearr[4] + ":" + timearr[5];
	}else{
		var timestr = ""+timearr[3]+":" + timearr[4] + ":" + timearr[5];
	}
	return timestr;
}
/*function getSomeOfMyVal() {
	return myplace + "+" + mycity;
}*/
//解析定位错误信息
/*function onError(data) {
	document.getElementById('tip').innerHTML = '定位失败';
}*/
/*function getGeolocation() {
	geolocation.getCurrentPosition();

}*/
//经纬度计算
function LngLat(longitude, latitude) {
	this.longitude = longitude;
	this.latitude = latitude;
}
function calculateLineDistance(start, end) {
	var d1 = 0.01745329251994329;
	var d2 = start.longitude;
	var d3 = start.latitude;
	var d4 = end.longitude;
	var d5 = end.latitude;
	d2 *= d1;
	d3 *= d1;
	d4 *= d1;
	d5 *= d1;
	var d6 = Math.sin(d2);
	var d7 = Math.sin(d3);
	var d8 = Math.cos(d2);
	var d9 = Math.cos(d3);
	var d10 = Math.sin(d4);
	var d11 = Math.sin(d5);
	var d12 = Math.cos(d4);
	var d13 = Math.cos(d5);
	var arrayOfDouble1 = [];
	var arrayOfDouble2 = [];
	arrayOfDouble1.push(d9 * d8);
	arrayOfDouble1.push(d9 * d6);
	arrayOfDouble1.push(d7);
	arrayOfDouble2.push(d13 * d12);
	arrayOfDouble2.push(d13 * d10);
	arrayOfDouble2.push(d11);
	var d14 = Math.sqrt((arrayOfDouble1[0] - arrayOfDouble2[0]) * (arrayOfDouble1[0] - arrayOfDouble2[0]) +
		(arrayOfDouble1[1] - arrayOfDouble2[1]) * (arrayOfDouble1[1] - arrayOfDouble2[1]) +
		(arrayOfDouble1[2] - arrayOfDouble2[2]) * (arrayOfDouble1[2] - arrayOfDouble2[2]));
	return(Math.asin(d14 / 2.0) * 12742001.579854401);
}
</script>